module.exports = __webpack_public_path__ + "img/czf_img_1@2x.4c3f5282.png";